import Layout from '@/layouts/Admin.vue'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import DirectSubscription from '@/views/admin/DirectSubscription/DirectSubscription.vue'
import Monitor from '@/views/admin/Monitor/Monitor.vue'
import Vue, { VueConstructor } from 'vue'
import Broadcast from '../../views/admin/Broadcast/Broadcast.vue'
import BulkUnsubscriptions from '../../views/admin/BulkUnsubscription/BulkUnsubscription.vue'
import Profile from '../../views/admin/Profile.vue'
import Report from '../../views/admin/Report/Report.vue'
import ReportAgend from '../../views/admin/Report/ReportAgend.vue'
import ReportView from '../../views/admin/Report/ReportView.vue'
import Statement from '../../views/admin/Statement/Statement.vue'
import WhitelistOneShot from '../../views/admin/WhitelistOneShot/WhitelistOneShot.vue'
import formRoutes from './forms'

const routes = [
    {
        path: '/manager',
        name: 'Admin',
        component: Layout as VueConstructor<Vue>,
        meta: { auth: 'admin' },
        children: [
            {
                path: 'home',
                name: 'Dashboard',
                meta: { auth: 'admin' },
                component: AdminDashboard
            },
            {
                path: 'support/:msisdn?',
                name: 'Monitor',
                meta: { auth: 'admin' },
                component: Monitor
            },
            {
                path: 'statement',
                name: 'Statement',
                meta: { auth: 'admin' },
                component: Statement
            },
            {
                path: 'bulk-unsubscriptions',
                name: 'BulkUnsubscriptions',
                meta: { auth: 'admin' },
                component: BulkUnsubscriptions
            },
            {
                path: 'broadcast',
                name: 'Broadcast',
                meta: { auth: 'admin' },
                component: Broadcast
            },
            {
                path: 'reports',
                name: 'Reports',
                meta: {
                    auth: 'admin',
                    permissionPrefix: 'report',
                    formRoute: 'ReportsForm'
                },
                component: Report
            },
            {
                path: 'reports/:reportId/view',
                name: 'ReportView',
                meta: {
                    auth: 'admin'
                },
                component: ReportView
            },
            {
                path: 'reports/:reportId/deliver-schedule',
                name: 'ReportAgend',
                meta: {
                    auth: 'admin'
                },
                component: ReportAgend
            },
            {
                path: 'profile',
                name: 'Profile',
                meta: { auth: 'admin' },
                component: Profile
            },
            {
                path: 'direct-subscription',
                name: 'DirectSubscription',
                meta: { auth: 'admin' },
                component: DirectSubscription
            },
            {
                path: 'whitelist-one-shot',
                name: 'WhitelistOneShot',
                meta: { auth: 'admin' },
                component: WhitelistOneShot
            },
            ...formRoutes
        ]
    }
]

export default routes
